import { render } from "./BusinessRegister2.vue?vue&type=template&id=729dbea8&scoped=true"
import script from "./BusinessRegister2.vue?vue&type=script&lang=js"
export * from "./BusinessRegister2.vue?vue&type=script&lang=js"

import "./BusinessRegister2.vue?vue&type=style&index=0&id=729dbea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729dbea8"]])

export default __exports__